import React, { useEffect, useState } from "react";
import "./Delegation.css";
import config from "../../config";
import { authFetch } from "../../utils/Security/authFetch";
import ApiDropdown from "../../Components/DropDown/Apidropdown";

interface Delegation {
  id?: number;
  delegatorId: number;
  delegatorName: string;
  interimId: number;
  interimName: string;
  startDate: string;
  endDate: string;
  period?: string;
}

const DelegationPage: React.FC = () => {
  const [delegations, setDelegations] = useState<Delegation[]>([]);
  const [formData, setFormData] = useState<Delegation>({
    delegatorId: 0,
    delegatorName: "",
    interimId: 0,
    interimName: "",
    startDate: "",
    endDate: "",
  });
  const [editingId, setEditingId] = useState<number | null>(null);

  const API_URL = `${config.apiBaseUrl}/api/delegations`;

  // Fetch delegations list
  useEffect(() => {
    fetchDelegations();
  }, []);

  const fetchDelegations = async () => {
    try {
      const response = await authFetch(API_URL);
      if (!response.ok) throw new Error("Failed to fetch delegations");
      const data = await response.json();
      setDelegations(data);
    } catch (error) {
      console.error("Error fetching delegations:", error);
    }
  };

  // Generic input change
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement> | { name: string; value: any }
  ) => {
    const { name, value } =
      "target" in e ? e.target : { name: e.name, value: e.value };
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Submit form (create or update)
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const method = editingId ? "PUT" : "POST";
      const url = editingId ? `${API_URL}/${editingId}` : API_URL;

      const response = await authFetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error("Error saving delegation");

      // Reset
      setFormData({
        delegatorId: 0,
        delegatorName: "",
        interimId: 0,
        interimName: "",
        startDate: "",
        endDate: "",
      });
      setEditingId(null);
      fetchDelegations();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  // Edit delegation
  const handleEdit = (delegation: Delegation) => {
    setEditingId(delegation.id!);
    setFormData({
      delegatorId: delegation.delegatorId,
      delegatorName: delegation.delegatorName,
      interimId: delegation.interimId,
      interimName: delegation.interimName,
      startDate: delegation.startDate,
      endDate: delegation.endDate,
    });
  };

  // Delete delegation
  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure you want to delete this delegation?"))
      return;

    try {
      const response = await authFetch(`${API_URL}/${id}`, {
        method: "DELETE",
      });
      if (!response.ok) throw new Error("Failed to delete delegation");
      fetchDelegations();
    } catch (error) {
      console.error("Error deleting delegation:", error);
    }
  };

  // Handle user dropdown (fetch user details)
  const handleUserSelect = async (
    type: "delegator" | "interim",
    id: number
  ) => {
    try {
      const res = await authFetch(`${config.apiBaseUrl}/api/users/${id}`);
      if (!res.ok) throw new Error("User not found");
      const user = await res.json();

      if (type === "delegator") {
        console.log("userrrrrrrrrrrrrrrrrrrrrrrrr", user);
        setFormData((prev) => ({
          ...prev,
          delegatorId: id,
          delegatorName: user.firstname,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          interimId: id,
          interimName: user.firstname,
        }));
      }
    } catch (err) {
      console.error(`Error fetching ${type} info:`, err);
    }
  };

  return (
    <div className="delegation-container">
      <h1>Delegation Management</h1>

      <form className="delegation-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <ApiDropdown
            api="users/fullnames"
            labelKey="fullName"
            valueKey="id"
            label="Delegator"
            onChange={(val) => {
              if (typeof val === "number" || !isNaN(Number(val))) {
                handleUserSelect("delegator", Number(val));
              }
            }}
          />

          <ApiDropdown
            api="users/fullnames"
            labelKey="fullName"
            valueKey="id"
            label="Interim"
            onChange={(val) => {
              if (typeof val === "number" || !isNaN(Number(val))) {
                handleUserSelect("interim", Number(val));
              }
            }}
          />
        </div>

        <div className="form-row">
          <label>Start Date:</label>
          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
            required
          />

          <label>End Date:</label>
          <input
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="submit-btn">
          {editingId ? "Update" : "Add"} Delegation
        </button>
      </form>

      <table className="delegation-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Delegator</th>
            <th>Interim</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Period</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {delegations.map((d) => (
            <tr key={d.id}>
              <td>{d.id}</td>
              <td>{`${d.delegatorName}`}</td>
              <td>{`${d.interimName}`}</td>
              <td>{d.startDate}</td>
              <td>{d.endDate}</td>
              <td>{d.period || "N/A"}</td>
              <td>
                <button className="edit-btn" onClick={() => handleEdit(d)}>
                  Edit
                </button>
                <button
                  className="delete-btn"
                  onClick={() => handleDelete(d.id!)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DelegationPage;
